import * as React from "react"
import {css} from "@emotion/react";
import {Button} from "../components/button";
import {Body} from "../components/Body";
import {Hero} from "../components/Hero";
import {CardsContainer, CardTitle, CardSubTitle, Card, ImageCard} from "../components/cards";
import {ListSpacer} from "../components/spacer";
import {Faq} from "../components/faq";
import {darkMint, eerieBlack, Colors} from "../styles/colors";
import {Spacing} from "../styles/spacing";
import {Typography} from "../styles/typography";
import {DesktopBr} from "../components/utils";
import {linkToScopriPreventivo} from "../links";
import Seo from "../components/Seo";
import coloreElettroniIllustration from '../images/pages/energia-sostenibile/colore-elettroni.svg'
import consumareEnergiaVerdeIllustration from '../images/pages/energia-sostenibile/consumare-energia-verde.svg'
import smartphoneConFogliIllustration from '../images/pages/energia-sostenibile/smartphone-con-fogli.svg'
import {Responsive} from "../styles/responsive";
import {cssOnlyMobile} from "../styles/utils";
import {SiteCTA} from "../components/SiteCTA";

const SostenibilePage = () => {

  return (
    <Body safe={false}>
      <Seo title={'Energia Sostenibile'}/>

      <Hero
        title={<>Energia verde, sostenibile, <DesktopBr/> green, rinnovabile</>}
        subtitle={<>Tutti ne parlano (e straparlano). Ma cosa significa davvero?</>}
      >
        <SiteCTA to={linkToScopriPreventivo()} name={'Passa al verde'} section={'hero'}>
          <Button limit={'true'} variant="none"
                  css={[Spacing.Padding.horizontal_54, Colors.Color.eerieBlack0, Colors.BackgroundColor.darkMint500, Spacing.Margin.top_40]}>
            <span css={[Typography.heading.h6_600]}>Passa al verde</span>
          </Button>
        </SiteCTA>
      </Hero>
      <CardsContainer backgroundColor={darkMint['500']}>
        <Card>
          <CardTitle>Non è possibile distinguere il colore degli elettroni</CardTitle>
          <CardSubTitle>La produzione di energia può essere non rinnovabile (combustibili fossili) o rinnovabile (dal
            sole, vento). Ma i due tipi di energia poi si mischiano nella stessa rete di distribuzione per arrivare a
            casa tua</CardSubTitle>
        </Card>
        <ListSpacer horizontalSize={36} verticalSize={40}/>
        <ImageCard css={[Spacing.Margin.top_32, Spacing.Margin.bottom_32]}>
          <img
            css={[cssOnlyMobile(Responsive.sizes.maxWidth)]}
            width={359} height={344}
            src={coloreElettroniIllustration}
            alt={''}
          />
        </ImageCard>
      </CardsContainer>

      <CardsContainer backgroundColor={eerieBlack["0"]}>
        <ImageCard css={[Spacing.Margin.top_32, Spacing.Margin.bottom_32]}>
          <img
            css={[cssOnlyMobile(Responsive.sizes.maxWidth)]}
            width={338}
            height={345}
            src={consumareEnergiaVerdeIllustration}
            alt={''}
          />
        </ImageCard>
        <ListSpacer horizontalSize={36} verticalSize={40}/>
        <Card>
          <CardTitle>Allora cosa vuol dire consumare energia verde?</CardTitle>
          <CardSubTitle>Significa finanziare i produttori di energia rinnovabile. Per ogni kWh di energia che consumerai
            con Tate ne verrà immesso un altro prodotto da fonti rinnovabili, grazie al meccanismo dei Certificati di
            Garanzie D’Origine. Senza sovraccosti in bolletta</CardSubTitle>
        </Card>
      </CardsContainer>

      <CardsContainer backgroundColor={darkMint['500']}>
        <Card>
          <CardTitle>C’è altro?</CardTitle>
          <CardSubTitle>Sì, non accettiamo bollettini postali né spediamo niente per posta. Ok, siamo smanettoni e
            propendiamo per tutto ciò che è tecnologico, ma lo facciamo anche per una scelta ecologica, così da evitare
            inutili sprechi di carta e aiutare l’ambiente</CardSubTitle>
        </Card>
        <ListSpacer horizontalSize={36} verticalSize={40}/>
        <ImageCard css={[css`height: 400px;`]}>
          <img
            css={[cssOnlyMobile(Responsive.sizes.maxWidth)]}
            width={337}
            height={346}
            src={smartphoneConFogliIllustration}
            alt={''}
          />
        </ImageCard>
      </CardsContainer>

      <Faq css={[Spacing.Margin.top_40]}/>
    </Body>)
}

export default SostenibilePage

